import { render, staticRenderFns } from "./tenantcompanyid.vue?vue&type=template&id=71281b2a&"
import script from "./tenantcompanyid.vue?vue&type=script&lang=js&"
export * from "./tenantcompanyid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports